import React from "react";

/**
 * RememberMeCheckbox - Checkbox for remembering user session
 *
 * @param {Object} props
 * @param {boolean} props.defaultChecked - Default checked state
 * @param {function} props.onChange - Change handler
 */
const RememberMeCheckbox = ({ defaultChecked = true, onChange }) => {
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }

    if (e.target.checked) {
      localStorage.setItem("rememberMePreference", "true");
    } else {
      localStorage.removeItem("rememberMePreference");
    }
  };

  return (
    <div className="mt-4 flex items-center">
      <input
        type="checkbox"
        id="remember-me"
        className="mr-2 h-4 w-4 accent-[--elita-primary] cursor-pointer"
        defaultChecked={defaultChecked}
        onChange={handleChange}
      />
      <label
        htmlFor="remember-me"
        className="text-sm text-gray-300 hover:text-white cursor-pointer transition-colors duration-200"
      >
        Remember me
      </label>
    </div>
  );
};

export default RememberMeCheckbox;
